import React from 'react'
import IconButton from '@mui/material/IconButton'
import DeleteOutline from '@mui/icons-material/DeleteOutline'

type Props = {
  onClick: () => void
}

// Trash icon that opens the clear-knock-status confirmation (SH-661).
// Tint matches the timestamp/clock row in the KNOCK STATUS box.
export function ClearKnockStatusButton({ onClick }: Props) {
  return (
    <IconButton
      size="small"
      aria-label="Clear knock status"
      onClick={onClick}
      sx={{ color: '#0E283FB2' }}
      data-test-id="clearKnockStatusBtn"
    >
      <DeleteOutline fontSize="small" />
    </IconButton>
  )
}
